import axios from 'axios';
import Mock from 'axios-mock-adapter';

const coreAxios = axios.create({ baseURL: `${window.API_URL}/api` });
const mockAxios = axios.create({ baseURL: '/', timeout: 1000 });

export const klwAxios = window.API_MOCK ? mockAxios : coreAxios;
export const webAxios = klwAxios;
const mockAxiosInst = window.API_MOCK ? mockAxios : axios;
export const mock = new Mock(mockAxiosInst, { delayResponse: 1500 });

export const setKringloopwijzerId = (kringloopwijzerId: number | null | undefined): void => {
	if (!kringloopwijzerId) {
		localStorage.removeItem('KringloopwijzerId');
		klwAxios.defaults.headers.common['Kringloopwijzer-Id'] = undefined;
		return;
	}

	const id = `${kringloopwijzerId}`;
	localStorage.setItem('KringloopwijzerId', id);
	klwAxios.defaults.headers.common['Kringloopwijzer-Id'] = id;
};

export const GetMijnJoinDataBaseUrl = (): string => window.JOIN_DATA_URL;
export const GetMijnJoinDataClientId = (): string => window.JOIN_DATA_CLIENT_ID;
